import SMBsIcon from 'images/organization/homepage/headerNavMenu/industries/smbs.svg'
import SchoolsIcon from 'images/organization/homepage/headerNavMenu/industries/schools.svg'
import MSPsIcon from 'images/organization/homepage/headerNavMenu/industries/msps.svg'
import NonProfitsIcon from 'images/organization/homepage/headerNavMenu/industries/non-profits.svg'
import StartupsIcon from 'images/organization/homepage/headerNavMenu/industries/startups.svg'
import PublicWifiIcon from 'images/organization/homepage/headerNavMenu/industries/public-wifi.svg'
import ChurchesIcon from 'images/organization/homepage/headerNavMenu/industries/churches.svg'
import EnterpriseIcon from 'images/organization/homepage/headerNavMenu/industries/enterprise.svg'

export const industries = [
  {
    header: 'Enterprise',
    icon: EnterpriseIcon,
    description: 'Secure DNS filtering for global workforces.',
    href: '/industries/enterprise',
  },
  {
    header: 'MSPs',
    icon: MSPsIcon,
    description: 'Empower your clients with hassle-free DNS layer protection.',
    href: '/industries/msps',
  },
  {
    header: 'SMBs',
    icon: SMBsIcon,
    description: 'Enhanced visibility and security for any workspace.',
    href: '/industries/smbs',
  },
  {
    header: 'Startups',
    icon: StartupsIcon,
    description: 'Protect and thrive with early startup security.',
    href: '/industries/startups',
  },
  {
    header: 'Non-Profits',
    icon: NonProfitsIcon,
    description: 'Prioritizing security for the common good.',
    href: '/industries/non-profits',
  },
  {
    header: 'Schools',
    icon: SchoolsIcon,
    description: 'Safeguarding online security for students and staff.',
    href: '/industries/schools',
  },
  {
    header: 'Faith Based Orgs',
    icon: ChurchesIcon,
    description: 'Offer family-friendly Wi-Fi.',
    href: '/industries/faith-based-organizations',
  },
  {
    header: 'Public Wi-Fi Operators',
    icon: PublicWifiIcon,
    description: 'Enhancing Wi-Fi hotspot security for guests.',
    href: '/industries/public-wifi-operators',
  },
]
